<template>
<div class="product-card-super" @click="goToProduct">
    
    <div class="product-img-wrapper">
      <div v-if="isSoldOut" class="badge-status-luxury out-of-stock">
        Agotado
      </div>
      <video
        v-if="firstMedia && firstMedia.type === 'video'"
        :src="firstMedia.url"
        class="product-media"
        autoplay
        muted
        loop
        playsinline
        preload="auto"
        ref="videoEl"
      ></video>
      <img
        v-else
        :src="firstMedia ? firstMedia.url : product.image"
        class="product-media"
      />
      
      <div v-if="isSoldOut" class="sold-out-overlay"></div>
    </div>

    <div class="product-info">
      <h3 class="product-name">{{ product.title }}</h3>

      <div class="product-price-container">
        <span class="currency-symbol">$</span>
        <span class="price-value">{{ displayPrice }}</span>
        <span v-if="showUnit" class="unit-price">usd</span>
      </div>
    </div>
<div class="qty-container-fixed">
      <div class="qty-box styled" :class="{ 'is-disabled': isSoldOut || hasSizes }">
        <button class="qty-btn" @click.stop="decrement" :disabled="isSoldOut">-</button>
        <div class="qty-display">
          {{ displayQty }}
          <span v-if="showUnit" class="unit-label-small">{{ unitLabel }}</span>
        </div>
        <button class="qty-btn" @click.stop="increment" :disabled="isSoldOut">+</button>
      </div>
    </div>
<button 
      class="add-btn"
      :class="{ 'btn-locked': isSoldOut, 'added': existsInCart() && !isSoldOut }"
      :disabled="isSoldOut"
      @click.stop="addToCart"
    >
      {{ hasSizes ? "Elegir talla" : (existsInCart() ? "Agregado ✔" : "Agregar") }}
    </button>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { useCart } from "@/components/composables/useCart";
import { useProduct } from "@/components/composables/useProduct";

const cartApi = useCart();

export default {
  name: "ProductCardSuper",

  props: {
    product: { type: Object, required: true }
  },

  data() {
    return {
      qty: 1,
      mode: "pz",
      currentVariantIndex: 0,
      productApi: null,
      noVariants: false
    };
  },

watch: {
  product: {
    immediate: true,
    handler() {
      this.qty = 1;
      this.mode = "pz";
      this.currentVariantIndex = 0;
      this.syncFromCart?.();
    }
  },

  cartVersion() {
    this.syncFromCart?.();
  }
},

  computed: {
    isSoldOut() {
    // Si availableQty es 0 y no passasasawdsadaasdasdasdasdasdasdasdermite backorder (pedidos pendientes)
    return this.product.availableQty <= 0 && !this.product.allowBackorder;
  },
    firstMedia() {
      if (!this.product?.media?.length) return null;
      const first = this.product.media[0];
      if (first.type === "video") return first;
      return { type: "image", url: this.product.image };
    },
    hasSizes() {
      const variants = this.product.variantes || [];
      if (!variants.length) return false;
      if (variants.length === 1 && variants[0].title === "Default Title") return false;
      return true;
    },
    hasPromoTag() { return this.hasPromo; },
    promoLabel() { return this.promoText; },
    hasPromo() {
      return Array.isArray(this.product.tags) &&
        this.product.tags.some(tag => tag.startsWith("promo-"));
    },
    promoText() {
      if (!Array.isArray(this.product.tags)) return "";
      const tag = this.product.tags.find(t => t.startsWith("promo-"));
      if (!tag) return "";
      let txt = tag.replace("promo-", "").replace(/-/g, " ");
      return /^\d+$/.test(txt) ? `${txt}% OFF` : txt.toUpperCase();
    },
    cartVersion() { return eventBus.cartUpdated; },
    variants() { return this.product.variantes || []; },
    currentVariant() {
      if (this.noVariants) return {};
      return this.variants[this.currentVariantIndex] || {};
    },
    showUnit() { return this.variants.length > 0; },
    unitLabel() {
      if (!this.variants.length) return "Pz";
      if (this.variants.length === 1) return this.variants[0].unit === "lb" ? "Lb" : "Pz";
      return this.mode === "lb" ? "Lb" : "Pz";
    },
    displayQty() { return this.mode === "lb" ? this.qty.toFixed(2) : this.qty; },
    hasMoreThanOneUnit() { return !this.noVariants && this.variants.length > 1; },
    nextModeLabel() { return this.mode === "lb" ? "Pz" : "Lb"; },
    displayPrice() {
      const price = cartApi.getDisplayPrice({
        product: this.product,
        unit: this.mode === "lb" ? "Lb" : "Pz"
      });
      return Number(price).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    },
    displayUnit() {
      if (!this.variants.length) return "Pz";
      if (this.variants.length === 1) return this.variants[0].unit === "lb" ? "Lb" : "Pz";
      return this.mode === "lb" ? "Lb" : "Pz";
    }
  },

  mounted() {
    this.activateVideoOnInteraction();
    this.$nextTick(() => {
      const video = this.$refs.videoEl;
      if (video) video.play().catch(() => {});
    });
    this.productApi = useProduct(this.product);
    this.checkVariants();
    this.syncFromCart();
    if (!this.existsInCart()) this.detectInitialMode();
  },

  methods: {
    activateVideoOnInteraction() {
      const playVideo = () => {
        const video = this.$refs.videoEl;
        if (video) {
          video.muted = true;
          video.play().catch(() => {});
        }
        window.removeEventListener('touchstart', playVideo);
        window.removeEventListener('scroll', playVideo);
        window.removeEventListener('click', playVideo);
      };
      window.addEventListener('touchstart', playVideo, { once: true });
      window.addEventListener('scroll', playVideo, { once: true });
      window.addEventListener('click', playVideo, { once: true });
    },
    syncFromCart() {
      const productId = this.product.id || this.product.product_id;
      if (this.hasSizes) return;
      const item = cartApi.findItem(productId);
      if (!item) {
        this.resetLocalState();
        return;
      }
      this.qty = item.qty;
      this.mode = item.unit === "Lb" ? "lb" : "pz";
    },
    goToProduct() {
      this.$router.push({
        name: "ProductPage",
        params: { handle: this.product.handle }
      });
    },
    resetLocalState() {
      this.qty = 1;
      this.mode = "pz";
      this.currentVariantIndex = 0;
    },
    existsInCart() {
      const productId = this.product.id || this.product.product_id;
      if (this.hasSizes) return false;
      return !!cartApi.findItem(productId);
    },
    checkVariants() {
      const variants = this.variants;
      if (!variants.length || (variants.length === 1 && variants[0].title === "Default Title")) {
        this.noVariants = true;
        return;
      }
      this.noVariants = false;
    },
    detectInitialMode() {
      if (!this.productApi || !this.productApi.hasVariants()) {
        this.mode = "pz";
        this.qty = 1;
        return;
      }
      this.mode = this.productApi.detectInitialMode();
      this.qty = this.productApi.getInitialQty(this.mode);
      const variant = this.productApi.getVariantByUnit(this.mode);
      if (variant) this.currentVariantIndex = this.variants.findIndex(v => v.id === variant.id);
    },
    increment() {
      this.qty = this.productApi.increaseQty(this.qty, this.mode);
      this.$nextTick(() => {
        if (this.existsInCart()) this.addToCart();
      });
    },
    decrement() {
      if (this.qty <= 0) return;
      this.qty--;
      if (this.existsInCart()) this.addToCart();
    },
    addToCart() {
      const productId = this.product.id || this.product.product_id;

      // 🔥 SI TIENE TALLAS → IR A PRODUCTO
      if (this.hasSizes) {
        this.goToProduct();
        return;
      }

      // 🔥 SI LA CANTIDAD ES 0 → ELIMINAR
      if (this.qty <= 0) {
        cartApi.removeItem(productId);
        return;
      }

      const variant = this.noVariants
        ? null
        : this.variants[this.currentVariantIndex];

      cartApi.upsertItem({
        product: { ...this.product, hasVariants: !this.noVariants },
        qty: this.qty,
        unit: this.mode === "lb" ? "Lb" : "Pz",
        variantId: variant ? variant.id : (this.product.variantId || this.product.id),
        variantes: this.variants || []
      });

      // 🔥 ABRIR sdasdasdasasdasdasdasasdasasdsdasdsA CON CLICK Y CON ADD)
      if (typeof eventBus.openCart === 'function') {
        eventBus.openCart();
      }
    }
  }
};
</script><style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&display=swap');

/* --- Reset de la Tarjeta --- */
.product-card-super {
  width: 100%;
  max-width: 260px;
  padding: 20px;
  border-radius: 24px;
  background: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 480px; /* Altura fija para que no salte al agotarse */
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  border: 1px solid #f2f2f2;
  font-family: 'Inter', sans-serif;
}

.product-card-super:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.08);
}

/* --- Contenedor Imagen/Video --- */
.product-img-wrapper {
  position: relative;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  border-radius: 12px;
}

.product-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.5s ease;
}

.product-card-super:hover .product-media {
  transform: scale(1.05);
}

/* --- 🔥 ETIQUETA LUXURY AGOTADO (LADO DERECHO) --- */
.badge-status-luxury {
  position: absolute;
  top: 10px;      /* Separación elegante del borde */
  right: 10px;    /* MOVIDO AL LADO DERECHO */
  background: #000;
  color: #fff;
  padding: 6px 14px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2px; /* Espaciado premium */
  z-index: 20;
  border-radius: 4px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
}

/* --- Texto --- */
.product-info { 
  height: 100px; /* Mantiene el selector de piezas en su lugar siempre */
}
.product-name {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
  height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* --- Precio Luxury --- */
.product-price-container {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  margin: 10px 0;
}

.currency-symbol { font-size: 14px; font-weight: 700; color: #111; margin-top: 3px; }
.price-value { font-size: 24px; font-weight: 800; color: #111; letter-spacing: -1px; }
.unit-price { font-size: 11px; color: #999; margin-left: 4px; }

/* --- Selector Cantidad (SIEMPRE VISIBLE) --- */
.qty-box.styled {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 160px;
  height: 42px;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  margin: 12px auto;
  background: #fafafa;
  transition: opacity 0.3s ease;
}

/* Inhabilitado visualmente sin mover el espacio */
.product-card-super.is-sold-out .qty-box.styled {
  opacity: 0.5;
  pointer-events: none; /* Bloquea clics en piezas */
}

.qty-btn {
  width: 40px;
  font-size: 18px;
  color: #333;
  background: transparent;
  border: none;
  cursor: pointer;
}

.qty-display { font-size: 16px; font-weight: 700; color: #111; }
.unit-label-small { font-size: 9px; color: #777; font-weight: 400; text-transform: uppercase; }

/* --- Botón Agregar Luxury --- */
.add-btn {
  width: 100%;
  background: #111;
  color: white;
  padding: 14px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  cursor: pointer;
  margin-top: auto;
}

.add-btn:hover:not(:disabled) {
  background: #000;
  transform: scale(1.02);
}

.add-btn.added {
  background: #e6e6e6;
  color: #333;
}

/* 🔥 BOTÓN AGOTADO INHABILITADO (Gris Premium) */
.add-btn:disabled, .btn-sold-out-luxury {
  background: #f2f2f2 !important; /* Gris seda muy suave */
  color: #b0b0b0 !important; /* Texto tenue */
  cursor: not-allowed !important;
  transform: none !important;
  font-weight: 600 !important;
}

.product-media::-webkit-media-controls { display: none !important; }
.product-media { pointer-events: none; }
</style>